export const FETCH_LOCATIONS = 'fetchLocations';
export const FETCH_GEOCODE = 'fetchGeoCode';
export const FETCH_UPS_LOCATIONS = 'fetchUpsLocations';
export const FETCH_MACYS_LOCATIONS = 'fetchStoresLocations';
export const FETCH_FCC_STORE_LOCATIONS = 'fetchFccStoresLocations';
export const SET_STORE = 'setStore';
export const FETCH_STORES_BY_ZIPCODE = 'fetchLocationsByZipCode';
export const RESET_STORE_ACTION = 'resetLocationStore';
export const FETCH_LOCATIONS_ADDRESS = 'fetchLocationByAddress';
export const FETCH_FEDEX_LOCATIONS = 'fetchFedexLocations';
